'use strict';

angular.module('services.grcCrontab', [])

    .factory('grcCrontabService', function () {
        /**
         * Custom crontab format based on crontab:
         *
         * Minutes | Hours | Days of Month | Months | Days of Week
         *     * * * * *
         *
         * Hours can have a custom ':00' part to define minutes. Allows for start and end times.
         *     e.g. '* 6:30-10:00 * * 1-5' <= Monday to Friday, 6:30 AM to 10:00 AM
         *
         * Start and End times are optional, can be declared as *
         *     e.g. '* *-10:00 * * *' or '* 6:30-* * * *'
         */

        var weekDaysToIndex = {
            'Sunday': 0,
            'Monday': 1,
            'Tuesday': 2,
            'Wednesday': 3,
            'Thursday': 4,
            'Friday': 5,
            'Saturday': 6
        };

        var weekDaysENFromIndex = Object.keys(weekDaysToIndex);

        return {
            /**
             * Custom Crontab parser.
             * Multiple comma separated values not supported for hours.
             * Only hours and days of week are parsed.
             *
             * Returns parsed values for start time, end time and days of the week as.
             * Start and end times are defined from 0:00 to 23:59
             * weekDays is the array of indexes e.g. [0, 3, 6]
             * weekDaysEN is an array of days in English e.g. ['Sunday', 'Wednesday', 'Saturday']
             *
             *     startTime: null | string
             *     endTime: null | string
             *     weekDays: null | int[]
             *     weekDaysEN: null | string[]
             *
             * @param crontab {string}
             * @returns {object}
             */
            parseCrontab: function(crontab) {
                var parsed = {
                    startTime: null,
                    endTime: null,
                    weekDays: null,
                    weekDaysEN: null
                };

                if (!crontab) return parsed;

                var values = crontab.trim().split(' ');
                if (values.length !== 5) return parsed;

                var times = values[1].split('-');

                // Start Time
                parsed.startTime = times[0] === '*' ? null : times[0];

                // Hours
                parsed.endTime = times[1] === '*' ? null : times[1];

                // Week days
                if (values[4] !== '*') {
                    parsed.weekDays = _.map(values[4].split(','), Number);
                    parsed.weekDaysEN = [];

                    _.each(parsed.weekDays, function(dayIdx) {
                        parsed.weekDaysEN.push(weekDaysENFromIndex[dayIdx]);
                    });
                }

                return parsed;
            },

            /**
             * Returns a custom Crontab format with start time, end time and list of days of the week
             *
             * e.g. '15:30', [0,3,4] => '30 15 * * 0,3,4'
             *
             * @param params {null|object}
             * @param params.startTime {null|string} 00:00 to 23:59
             * @param params.endTime {null|string} 00:00 to 23:59
             * @param params.weekDays {null|int[]} days of the week as [1, 5]
             * @param params.weekDaysEN {null|string[]} days of the week in English as ['Monday', 'Friday']
             *
             * @returns {string} custom GRC crontab format
             */
            toCrontab: function(params) {
                if (!params) params = {};

                // Remove leading zeros and set as * if  necessary
                var startTime = this.parseTime(params.startTime);
                params.startTime = (startTime === null) ?
                    '*' :
                    startTime.hours + ':' + _.padStart(startTime.minutes, 2,  '0');

                // Remove leading zeros and set as * if  necessary
                var endTime = this.parseTime(params.endTime);
                params.endTime = (endTime === null) ?
                    '*' :
                    endTime.hours + ':' + _.padStart(endTime.minutes, 2,  '0');

                // [0, 3] to '0,3'
                params.weekDays = (!params.weekDays || !params.weekDays.length) ? '*' : _.join(params.weekDays, ',');

                return '* ' + params.startTime + '-' + params.endTime + ' * * ' + params.weekDays;
            },

            /**
             * From an array of English days of a week, to an array of crontab indexes
             * @param daysOfWeek {string[]} as ['Sunday', 'Wednesday']
             * @returns {int[]} indexes as [0, 3]
             */
            getWeekDaysIndexes: function(daysOfWeek) {
                return _
                    .chain(daysOfWeek)
                    .map(function(day) { return weekDaysToIndex[day] })
                    .value();
            },

            /**
             * From '00:00' to {hours: 0, minutes: 0}
             * @param time {string}
             * @returns {object|null} as {hours: number, minutes: number}
             */
            parseTime: function(time) {
                if (!time) return null;

                var split = time.split(':');
                if (split.length !== 2) return null;

                var hours = Number(split[0]);
                var minutes = Number(split[1]);

                if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

                return {
                    hours: hours,
                    minutes: minutes
                };
            }
        };
    });
